import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { Check, ChevronDown } from 'lucide-react';

import { Universe } from '../../types';
import { Button } from '../ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '../ui/Dropdown-Menu';

type Props = {
    universes: Universe[];
    currentUniverse?: Universe | null;
};

export const MobileUniverseDropdown: FC<Props> = ({
    universes,
    currentUniverse,
}) => {
    const selectedUniverse = currentUniverse ?? universes[0];

    if (!selectedUniverse) {
        return null;
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="ghost"
                    className="h-8 max-w-[170px] shrink md:hidden"
                    data-testid="mobile-universe-trigger"
                >
                    <span className="truncate text-sm font-medium">
                        {selectedUniverse.name}
                    </span>
                    <ChevronDown className="h-3.5 w-3.5 shrink-0" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className="w-56 md:hidden"
                align="center"
                sideOffset={8}
                data-testid="mobile-universe-dropdown"
            >
                {universes.map((universe) => (
                    <DropdownMenuItem key={universe.id} asChild>
                        <Link
                            href={universe.url_path}
                            className="flex w-full items-center justify-between gap-2"
                        >
                            <span className="truncate">{universe.name}</span>
                            {universe.id === selectedUniverse.id && (
                                <Check
                                    className="h-4 w-4 shrink-0 text-primary"
                                    aria-hidden="true"
                                />
                            )}
                        </Link>
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
